import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n\n  padding: 6px 8px;\n  gap: 4px;\n\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(17px);\n  border-radius: 8px;\n\n  svg {\n    width: 24px;\n    height: 24px;\n\n    transition: transform 0.3s;\n  }\n  :hover {\n    svg {\n      transform: scale(1.2);\n    }\n  }\n\n  div {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 150%;\n\n    color: #ffffff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import LogoOpx from "../Svg/Icons/LogoOpx";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
var PriceLink = styled.a.withConfig({
    componentId: "sc-5939e9e7-0"
})(_templateObject());
var CakePrice = function(param) {
    var cakePriceUsd = param.cakePriceUsd, _color = param.color, color = _color === void 0 ? "textSubtle" : _color, _showSkeleton = param.showSkeleton, showSkeleton = _showSkeleton === void 0 ? true : _showSkeleton;
    return cakePriceUsd ? /*#__PURE__*/ _jsxs(PriceLink, {
        href: "https://pancakeswap.finance/swap?outputCurrency=0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82&chainId=56",
        target: "_blank",
        children: [
            /*#__PURE__*/ _jsx(LogoOpx, {
                width: "24px"
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: color,
                bold: true,
                children: "$".concat(cakePriceUsd.toFixed(3))
            })
        ]
    }) : showSkeleton ? /*#__PURE__*/ _jsx(Skeleton, {
        width: 80,
        height: 24
    }) : null;
};
export default /*#__PURE__*/ React.memo(CakePrice);
